export const postData = async function postData(url, user) {
    try {
        const response = await fetch(url, {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          redirect: "follow",
          referrerPolicy: "no-referrer",
          body: JSON.stringify(user),
        });
        
        // If the response status is 204, there is no content, so don't attempt to parse JSON
        if (response.status === 204) {
          return { status: "Success", message: "Update successful!" };
        }

        if (!response.ok) { 
          const errorData = await response.json();
          throw new Error(errorData.message || 'Something went wrong');
        }
    
        return response.json();

      } catch (error) {
        console.error('Error:', error);
        throw error; 
      }

    }